import $ from 'jquery'
import Model from './src/model'
import View from './src/view'
import './less/main.less'
import format from 'date-fns/format'

const licenseAgreement = require('./templates/licenseAgreement.ejs')
const listItem = require('./templates/listItem.ejs')
const controllersTemplate = require('./templates/controllers.ejs')
const lockedTemplate = require('./templates/locked.ejs')
const confirmModal = require('./templates/confirmModal.ejs')
const userDetailsTemplate = require('./templates/userDetails.ejs')
const userDetailsPaypalTemplate = require('./templates/userDetailsPaypal.ejs')


// this is the real code
const redeem = new Model({
    fetch: '../Redeems.ashx',
    delete: '../Redeems.ashx',
    save: '../Redeems.ashx'
});

const user = new Model({fetch: '../Customer.ashx'});
const license = new Model({save: '../License.ashx'});

const modalHelper = {
  el: '.modal',
  body: '.body',
  preload: '.preload',
  template: confirmModal
}

var licenceView = new View({
  el: '.wrapper',

  model: license,

  template: licenseAgreement,

  ui: {
    checkBox: '.agree-cb',
    checkLabel: '.grey-gradient',
    btn: '.btn-agree'
  },

  events: {
    'click @.btn-agree': 'agree',
    'click @.agree-cb': 'check'
  },

  check: function () {
    if (this.ui.checkBox.is(':checked')) {
      this.ui.btn.removeClass('disabled')
    } else {
      this.ui.btn.addClass('disabled')
    }
  },

  agree: function () {
    if (this.ui.checkBox.is(':checked')) {
      this.model.save(1).done(() => document.location.reload())
    }
  }
})

var redeemView = new View({
  el: '.redeem-table',

  template: listItem,

  model: redeem,

  ui: {
    toAnimate: '[data-animate]'
  },

  events: {
    'click @.btn-delete': 'callDelete'
  },

  modalHelper: modalHelper,

  callDelete: function () {
    this.showModal({
      bgColor: '',
      icon: 'question-circle',
      title: 'Attention!',
      message: 'Are you sure you want to delete this redeem request?',
      confirm: true,
      cancel: true
    })
  },

  onConfirm: function () {

    this.modalStartPreload()

    this.model
      .delete()
      .fail(() => {
        this.hideModal()
        this.showModal({
          bgColor: '',
          icon: 'warning',
          title: 'Error',
          message: 'There was an error deleting your redeem, please try again',
          ok: true
        })
      })
      .done(() => {
        document.location.reload()
      })
  },

  onRender: function () {
    $('[data-animate]').each(function () {
      $(this).addClass($(this).attr('data-animate'))
    })
  }
})

var controllersView = new View({
  el: '.amount-form',

  model: redeem,

  modalHelper: modalHelper,

  selectedPaymentMethod: 'check',

  ui: {
    'value': '.redeem-amount',
    'dollar': '.dollar-equivalent',
    'clear': '.clear',
    'redeemAll': '.btn-all',
  },

  events: {
    'keyup @.redeem-amount': 'updateNote',
    'keypress @.redeem-amount': 'onlyDigits',
    'click @.btn-new': 'validate',
    'click @.btn-clear': 'clear',
    'click @.btn-all': 'redeemAll',
    'click @@.btn-select': 'clickPaymentMethod'
  },

  clickPaymentMethod: function(e) {
    this.selectedPaymentMethod = e.currentTarget.name
    if (this.selectedPaymentMethod === 'check') {
      $('.boxColumn.check').addClass('selected')
      $('.boxColumn.paypal').removeClass('selected')
    } else {
      $('.boxColumn.paypal').addClass('selected')
      $('.boxColumn.check').removeClass('selected')
    }
  },

  onlyDigits: function (e) {
    const val = parseInt(String.fromCharCode(e.charCode), 10)
    if (parseInt(val) !== val) {
      return e.preventDefault()
    }
  },

  updateNote: function (e) {
    const val = this.ui.value.val() / 100
    this.ui.dollar.text(`(= $${parseFloat(val).toFixed(2)})`)
  },

  redeemAll: function () {
    this.ui.value.val(user.get('balance'))
    this.updateNote();
    this.validate();
  },

  validate: function () {

    let val = this.ui.value.val()

    let userBalance = user.get('balance')
    let minVal = 100
    let maxVal = 50000

    let message = 'Please enter an amount'

    if (userBalance < minVal) {
      message = `You have ${userBalance ? userBalance : 0} Winning Entries.<br>The minimum redeemable amount is 100 points.<br>Please try again later.`
    }
    else {
      if (val === 0 || val < minVal) {
        message = 'The minimum amount is 100.<br>Please change your amount.'
      }
      if (val > userBalance) {
        message = `Your available Winnings are ${userBalance} Entries.<br>Please change your amount.`
      }
      if (val > maxVal) {
        message = 'The max amount is 50,000.<br>Please change your amount.'
      }
    }

    if (val < minVal || val > maxVal || val > userBalance) {
      return this.showModal({
        bgColor: '',
        icon: 'warning',
        title: 'Please Check amount',
        message: message,
        ok: true
      })
    }

    this.fetchFromModel()
  },

  clear: function () {
    this.ui.value.val('')
    this.ui.dollar.text('')
  },

  onData: function (data) {
    data = parse(data)

    let dollarIn = parseFloat(this.ui.value.val() / 100).toFixed(2)
    let pointsIn = parseInt(dollarIn * 100)

    if (data.current.id === 0) {
      this.showModal({
        bgColor: '',
        icon: 'info-circle',
        title: 'Please read',
        message: `This is a request for<br>
                        ${pointsIn} points = $${dollarIn} dollars.<br>Continue?`,
        confirm: true,
        cancel: true
      })
    } else {

      let dollarOut = parseFloat(data.current.value / 100).toFixed(2)
      let pointsOut = parseInt(dollarOut * 100)

      this.showModal({
        bgColor: '',
        icon: 'info-circle',
        title: 'Please read',
        message: `This redeem of<br>
                        ${pointsIn} points = $${dollarIn} dollars<br>
                        will replace an existing request of ${pointsOut} points = $${dollarOut} dollars.<br>Continue?`,
        confirm: true,
        cancel: true
      })
    }
  },

  onConfirm: function () {

    this.modalStartPreload()

    redeem
      .save(this.ui.value.val(), this.selectedPaymentMethod)
      .done((data) => {
        window.location.reload()
      })
      .fail(() => {
        this.onSave(false)
      })
  },

  onSave: function (data) {

    let modalSettings = {
      bgColor: '',
      icon: 'warning',
      title: 'Please Read',
      message: 'There was a problem with your request, please try again',
      ok: true
    }

    if (data) {
      modalSettings = {
        bgColor: 'green',
        icon: 'check-square',
        title: 'Well done!',
        message: 'Your request was successfully registered',
        ok: true
      }
    }

    this.showModal(modalSettings)
  }
})

var userDetailsView = new View({
  el: '.user-details',
  getTemplate: function(data) {
    console.dir(data)
    if (!data || !data.paypalAccount || data.paypalAccount === "") {
      console.log(`userDetailsTemplate`)
      return userDetailsTemplate
    } else {
      console.log(`userDetailsPaypalTemplate`)
      return userDetailsPaypalTemplate
    }
  },
  modalHelper: modalHelper,

  checkUserDetails: function (data) {

    data.balance = parseInt(data.balance)

    for (var key in data) {
      if (data[key] === '' && key !== 'paypalAccount') {
        data[key] = 'incomplete'
        data.missingValues = true

        this.showModal({
          bgColor: '',
          icon: 'warning',
          title: 'Very Important',
          message: 'You may not place a Redeem Request at this time.<br>Your account is missing important information.<br>Please contact support'
        })
      }
    }

    return data
  },

  failedFetch: function () {
    return this.showModal({
      bgColor: '',
      icon: 'warning',
      title: 'Important Notice',
      message: 'There was a problem retrieving your information.<br>Please login again'
    })
  }
})

const parse = (data) => {

  var payout = {
    current: null,
    prev: null
  }

  data.forEach(x => {
    if (x.week === 'prev') {
      payout.prev = x
      payout.prev.value = parseInt(x.value)
      payout.prev.id = x.id === '' ? 0 : x.id

      payout.prev.prevRange =
        format(x.from, 'MMM D') + ' - ' +
        format(x.to, 'D')

      payout.prev.prevDate =
        format(x.date, 'ddd, h:mm a')

      payout.prev.prevSentDate =
        x.status === 'sent' ? ': ' + format(x.processedDate, 'ddd, MMM D') : ''

    } else {
      payout.current = x
      payout.current.value = parseInt(x.value)
      payout.current.id = x.id === '' ? 0 : x.id

      payout.current.currentRange =
        format(x.from, 'MMM D') + ' - ' +
        format(x.to, 'D')

      payout.current.currentDate =
        format(x.date, 'ddd, h:mm a')
    }
  })
  return payout
}
var lastBalance = undefined
const refreshRedeems = (userData) => {
  if (!lastBalance) {
    lastBalance = userData.balance || 0
  }
  redeem.fetch().done((redeemData) => {
    var data = parse(redeemData)
    var isLocked = data.current.locked !== "0"
    redeem.attributes = data
    redeemView.model = redeem
    redeemView.render(data)

    controllersView.getTemplate = function () {
      return isLocked ? lockedTemplate : controllersTemplate
    }
    controllersView.render()

    if (isLocked) {
      delete userDetailsView.__data.paypalAccount
      userDetailsView.render(userDetailsView.__data)
    }

    $('.btn-all').html(`Request ${lastBalance} pts`)

    if(data && data.prev) {
      $('.abc').text(parseFloat(data.prev.abc).toFixed(2))
    }
  })
}

$(document).ready(() => {

  user.fetch()
    .done((userData) => {

      if (userData.needLicenseAgreement == 1) {

        $('.wrapper').empty()

        licenceView.render()

        return
      }

      userDetailsView.render(userDetailsView.checkUserDetails(userData))

      if (!userData.missingValues) {   
        refreshRedeems(userData)
      }
    })
    .fail(() => {
      console.log('error')
      userDetailsView.failedFetch()
    })
    .always(() => {
      $('.wrapper').show()
    })


})


